import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { GlobalSettingsService } from './global-settings.service'; 

@Injectable({ providedIn: 'root' })

export class IncomeCallService {
  private socket: any;
  private cronSocket: any;
  private socketsInitialized = false;
  public uniqueUserId: any;
  public IncomingCallSubject = new Subject(); 
  constructor(private urlService: GlobalSettingsService, private zone: NgZone) {}

  intializeIncomeSocket() {
    if (this.socketsInitialized) {
      return;
    }
    this.socketsInitialized = true;
    this.socket = io(this.urlService.getIncomingUrl(), {
      path: '',
transports: ['websocket']
    });
    this.cronSocket = io(this.urlService.getCronUrl(), {
      path: '',
transports: ['websocket']
    });
  }

  public send(message: any): void {
    this.socket.emit('message', message);
  }

  public closeSockets(): void {
    this.socket.disconnect();
    this.cronSocket.disconnect();
  }

  private ignosisRoom = '';
  private ignosisJoinBound = false;
  private ignosisOfferBound = false;
  private ignosisOffer$ = new Subject<any>();

  joinIgnosisRoom(room: string) {
    this.intializeIncomeSocket();
    this.bindIgnosisOffer();
    const name = String(room || '');
    if (!/^ignosis-\d+$/.test(name) || !this.socket || name === this.ignosisRoom) return;
    this.ignosisRoom = name;
    const join = () => {
      if (!this.ignosisRoom) return;
      this.socket.emit('ignosis_agent', this.ignosisRoom);
      console.log('ignosis socket joined', this.ignosisRoom);
    };
    if (!this.ignosisJoinBound) {
      this.ignosisJoinBound = true;
      this.socket.on('connect', join);
    }
    if (this.socket.connected) join();
  }

  private bindIgnosisOffer() {
    if (this.ignosisOfferBound || !this.socket) return;
    this.ignosisOfferBound = true;
    this.socket.on('ignosis_transfer_offer', (data: any, ack?: (response?: any) => void) => {
      const ok = !!(data && data.url && data.roomName && data.token);
      console.log('ignosis transfer offer received', { roomName: data && data.roomName, ok });
      if (typeof ack === 'function') ack({ accepted: ok, reason: ok ? '' : 'invite' });
      if (ok) this.zone.run(() => this.ignosisOffer$.next(data));
    });
  }

  public onIgnosisTransferOffer(): Observable<any> {
    this.intializeIncomeSocket();
    this.bindIgnosisOffer();
    return this.ignosisOffer$.asObservable();
  }

  public onMessage(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('message', (data: any, ack?: (response?: any) => void) => {
        console.log("data", data)
        observer.next(data)
        if (typeof ack === 'function') {
          ack(true);
        }
      });
    });
  }
  public onCallEmit(agentName: any): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.emit('oz_agent', agentName);
    });
  }

  public onEvent(event: any): Observable<any> {
    return new Observable<Event>(observer => {
      this.socket.on(event, (data: any) => observer.next(data));
    });
  }

  public onIncomeConnect(): Observable<void> {
    this.intializeIncomeSocket();
    return new Observable((observer) => {
      const handler = () => observer.next();
      if (this.socket.connected) handler();
      this.socket.on('connect', handler);
      return () => this.socket.off('connect', handler);
    });
  }

  public onCronEvent(event: any): Observable<any> {
    return new Observable<Event>(observer => {
      this.cronSocket.on(event, (data: any) => observer.next(data));
    });
  }

  public onInstructEscalateEmit(userUniqueId: any): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.emit('instruct_escalate',userUniqueId);
    });
  }
  public paymentDateNotification(userId: any): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.emit('payment_date_notification', Number(userId));
    });
  }

  public onCronInstructEscalateEmit(userUniqueId: any): Observable<any> {
    return new Observable<any>(observer => {
     this.cronSocket.emit('instruct_escalate', userUniqueId);
    });
  }

  public onInstructEscalate(): Observable<any> {
    return new Observable<Event>(observer => {
      this.socket.on('instruct_escalate_message', (data: any) => {
        console.log('111111',data);
        
        observer.next(data);
      });
    });
  }
  public onPaymentDateNotification(): Observable<any> {
    return new Observable<Event>(observer => {
      this.socket.on('payment_date_notification_message', (data: any) => {
        console.log('karan',data);
        
        observer.next(data);
      });
    });
  }

  public onPositiveCustomerResponse(): Observable<any> {
    return new Observable<Event>(observer => {
      this.socket.on('customer_response_alert', (data: any) => {
        console.log('karan2',data);
        
        observer.next(data);
      });
    });
  }

  public onInstructEscalateonCron(): Observable<any> {
    return new Observable<Event>(observer => {
      this.cronSocket.on('instruct_escalate_message', (data: any) => {
        console.log('instruct_escalate_message',data);
        
        observer.next(data);
      });
    });
  }

  public getcallingData(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('progressive_dialer', (data: any) => {
        observer.next(data);
      });
    });
  }


  public onSettlePageMessage(): Observable<any> {
    return new Observable<Event>(observer => {
      this.socket.on('settle_page_message', (data: any) => {
        observer.next(data);
      });
    });
  }

  public joinSettlePageSocket(settle_unique_defaulter_code: any): Observable<any>{
    return new Observable<Event>(observer => {
     this.socket.emit('settle_page', settle_unique_defaulter_code,(response: any)=>{
     });
     observer.next();
    });
  }

  public getCubeCallEvent(): Observable<any>{
    return new Observable<Event>(observer => {
      this.socket.on('cube_callback_event', (data: any) =>
      observer.next(data));
    });
  }

  public onCubeDialerLeadsUploaded(): Observable<any> {
    return new Observable((observer) => {
      this.socket.on('cube_dialer_leads_uploaded', (data: any) => observer.next(data));
    });
  }

  public onCubeManualDialRequest(): Observable<any> {
    return new Observable((observer) => {
      this.socket.on('cube_manual_dial_request', (data: any) => observer.next(data));
    });
  }

  public sendSettlePageRespone(response: any): Observable<any>{
    return new Observable<Event>(observer => {
      this.socket.emit('settle_page_callback', response);
      observer.next();
    });
  }

  public updateisSeenFlag(): Observable<any> {
    return new Observable<Event>(observer => {
      this.socket.on('update_notification_isSeenflag', (data: any) => {
        
        observer.next(data);
      });
    });
  }

  setCallingRes(callRes: any){
    sessionStorage.setItem('callingRes',JSON.stringify(callRes));
  }
  getCallingRes(){
   const callRes =  sessionStorage.getItem('callingRes');
   if(callRes){
    return JSON.parse(callRes);
   }
   else return callRes;
  }

  removeCallingRes(){
    sessionStorage.removeItem('callingRes');
  }

  delay(time: any):Promise<any>{
     return new Promise((resolve,reject)=>{
      setTimeout(resolve,time);
     })
  }
  public foceLogout(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('force_logout', (data: any) => {
        console.log("data", data)
        observer.next(data)
      });
    });
  }

  
}
